import { useEffect, useState } from "react";
import { Dropdown } from "../../../shared/dropdown/Dropdown";
import './SelectPayment.scss';
import { getOrderType } from "../../helpers/Api";

export const SelectPayment = ({ selectedOption, setSelectedOption, formik }) => {

    const [paymentOptions, setPaymentOptions] = useState([]);

    useEffect(() => {
        getOrderType().then((res) => {
            setPaymentOptions(res.data)
        });
    }, []);


    return (
        <div className="payment-for-error-wrapper">
            <Dropdown
                formik={formik}
                items={paymentOptions}
                selectedValue={selectedOption}
                setSelectedValue={setSelectedOption}
                valueKey="id"
                labelKey="text"
                placeholder='Способ оплаты'
                className='payment'
                buttonClassName='payment-btn'
                menuClassName='payment-list'
                itemClassName='payment-item'
                icon={<svg width="25" height="23" viewBox="0 0 25 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M15.1436 0.637695C15.4562 0.340146 15.9393 0.333655 16.2598 0.608398L16.3213 0.666992L19.1484 3.64062C20.9157 3.64818 22.3563 5.09337 22.3564 6.8623V12.293H23.2852C24.0357 12.293 24.6465 12.9039 24.6465 13.6543V17.1299C24.6462 17.88 24.0355 18.4902 23.2852 18.4902H22.3564V19.498C22.3564 21.2716 20.9083 22.7196 19.1348 22.7197H3.97168C2.19801 22.7197 0.75 21.2717 0.75 19.498V6.8623L0.753906 6.69727C0.840482 4.99978 2.25341 3.64062 3.97168 3.64062H11.9854L15.1436 0.637695ZM3.97168 5.31055C3.11996 5.31055 2.42004 6.01061 2.41992 6.8623V19.498C2.41992 20.3498 3.11983 21.0498 3.97168 21.0498H19.1348C19.9865 21.0497 20.6865 20.3497 20.6865 19.498V18.4902H17.8447C17.0952 18.4902 16.4837 17.8779 16.4834 17.1299V13.6543C16.4834 12.905 17.0961 12.293 17.8447 12.293H20.6865V9.80371H5.51562C5.25438 9.80364 5.04101 9.70109 4.89551 9.53516C4.75428 9.37407 4.68852 9.16726 4.68848 8.96875C4.68848 8.77016 4.75421 8.56251 4.89551 8.40137C5.041 8.23559 5.25452 8.13386 5.51562 8.13379H7.25879L10.2275 5.31055H3.97168ZM20.75 16.8203H22.9766V13.9629H20.75V16.8203ZM18.1533 16.8203H19.0801V13.9629H18.1533V16.8203ZM20.1592 5.7041C20.131 5.74223 20.1008 5.7797 20.0654 5.81348L17.625 8.13379H20.6865V6.8623C20.6865 6.41395 20.4886 5.99586 20.1592 5.7041ZM9.68066 8.12988L15.2354 8.10449L18.3115 5.17969C17.4369 4.25972 16.5621 3.33989 15.6875 2.41992C13.6852 4.32332 11.6827 6.22627 9.68066 8.12988Z" fill="#5E9C81" stroke="#5E9C81" strokeWidth="0.5" />
                </svg>
                }
                arrow={<svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9.17806 15.133C9.2698 15.2662 9.39255 15.3751 9.53575 15.4504C9.67895 15.5257 9.83829 15.565 10.0001 15.565C10.1618 15.565 10.3212 15.5257 10.4644 15.4504C10.6076 15.3751 10.7303 15.2662 10.8221 15.133L19.8221 2.13297C19.9262 1.98302 19.9873 1.8074 19.9987 1.62517C20.0101 1.44295 19.9713 1.26109 19.8865 1.09936C19.8018 0.93763 19.6744 0.802213 19.5181 0.707823C19.3618 0.613433 19.1826 0.563678 19.0001 0.563966H1.00006C0.817902 0.564718 0.639397 0.615113 0.483739 0.709729C0.328082 0.804345 0.201162 0.939604 0.116628 1.10096C0.0320935 1.26231 -0.0068559 1.44366 0.00396806 1.6255C0.014792 1.80733 0.0749798 1.98278 0.178059 2.13297L9.17806 15.133Z" fill="#5E9C81" />
                </svg>}
            />
            {selectedOption?.id === 2 &&
                <div className="payment-error">Оплата картой временно недоступна!</div>
            }

        </div>
    )
}